<template>
  <div>
    <add-or-update-patient-modal
      :is-referenced="true"
      :is-add-active.sync="toggleModal"
      @refetchData="() => patients = []"
    />

    <div class="d-flex align-content-between align-items-start">
      <v-select 
        class="flex-grow-1"
        :value="value" 
        :loading="loading"
        :options="patients" 
        :close-on-select="true"
        :reduce="val => val.id" 
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" 
        label="name" 
        clearable 
        @search="fetchPatients"
        @input="onOptionSelected"
      >
        <template #list-header>
          <li class="d-flex align-content-between align-items-center" style="opacity: 0.8; text-align: center; padding: 5px;">
            <div class="flex-grow-1">Start typing to fetch patients</div>
          </li>
        </template>

        <template #no-options>
          No options available
        </template>
      </v-select>

      <div v-if="can('patients:CanAddNew')">
        <b-button size="sm" variant="no-outline" @click="onAddNew">
          <feather-icon icon="PlusCircleIcon" size="25" color="dodgerblue"></feather-icon>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';
import { BButton } from 'bootstrap-vue'

import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import AddOrUpdatePatientModal from '@/@core/components/shared/admin/modals/AddOrUpdatePatientModal.vue';

export default {
  components: {
    vSelect,
    BButton,

    AddOrUpdatePatientModal
  },
  props: {
    value: {
      default: "",
      type: String,
      required: false,
    }
  },
  data() {
    return {
      loading: false,
      toggleModal: false,

      patients: [],
      storeName: "patientFrequencyStore",
    }
  },
  created() {
    if (this.value){
      this.fetchPatients(this.value, () => {});
    } else {
      this.patients = this.getFrequencyStore(this.storeName)
    }
  },
  methods: {
    async fetchPatients(text, loadingMutator) {
      try {
        this.loading = true; 
        loadingMutator(true);

        const query = {
          page: 1,
          limit: 50,
          search: text || this.value,
        }

        const request = await this.useJwt().mainService.patients.list(query);
        const { data } = request.data;
        this.patients = data.map(opt => ({ id: opt._id, name: `${opt.full_name} | ${opt.phone} | ${this.formatDate(opt.date_of_birth, 'dd-MM-yyyy')} | Age: ${opt.age}` }))
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
        loadingMutator(false);
      }
    },
    onOptionSelected(patient_id){
      this.$emit('change', patient_id)

      const selectedOption = this.patients.find(record => record.id === patient_id);
      if (selectedOption) {
        this.updateFrequencyStore(this.storeName, selectedOption);
      }
    },
    onAddNew(){
      this.toggleModal = true;
    },
  }
}
</script>
